var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bottom-bar"},[_c('p',{staticClass:"bottom-bar-txt"},[_vm._v("\n         Copyright © 2026 All Rights Reserved By\n         "),_c('a',{staticStyle:{"color":"rgba(240, 206, 13, 0.937)"},attrs:{"href":"https://www.tsehaybank.com.et/","target":"_blank","rel":"noopener"}},[_vm._v("Tsehay bank S.C.")])])])
}]

export { render, staticRenderFns }